import { z } from 'zod';
import { Car, CarSchema } from '@/types/car/car.type.ts';
import { PaginationMeta, PaginationMetaSchema } from '@/types/pagination-meta.ts';
import { CarStatus } from '@/types/car/car-status.type.ts';
import { CarAdmissionType } from '@/types/car/admission-type.type.ts';
import { CarNdsType } from '@/types/car/car-nds-type.ts';
import { CarTransmissionType } from '@/types/car/car-transmission-type.type.ts';

export type CarsPaginator = {
    data: Car[],
    meta: PaginationMeta,
};

export type CarsRequestFilter = {
    vin?: string,
    city_id?: number[],
    dealer_id?: number[],
    status?: CarStatus[],
    brand_id?: number[],
    model_id?: number[],
    admission_type?: CarAdmissionType[],
    nds_type?: CarNdsType[],
    transmission_type?: CarTransmissionType[],
    from_sale_date?: string,
    to_sale_date?: string,
    production_year: [number, number],
    mileage: [number, number],
    start_price: [number, number],
    is_confirmation_required?: 0 | 1,
    is_active?: 0 | 1,
    page: number,
    sort?: Record<string, string>[],
};

export const CarsPaginatorSchema = z.object({
    data: z.array(CarSchema),
    meta: PaginationMetaSchema,
});
